import React, { useState, useEffect } from 'react'
import './App.css'

import {
  BrowserRouter as Router,
  Switch,
  Route,
} from 'react-router-dom'


import { SnackbarProvider } from 'notistack'


import ScaleVisualizer from './ScaleVisualizer'
import { createMuiTheme, makeStyles, ThemeProvider } from '@material-ui/core'

import tunings from './tunings'
import ChordFinder from './ChordFinder'
import indigo from '@material-ui/core/colors/indigo'

// import WalkingBassGenerator from './WalkingBassGenerator'
import TinyDaw from './tinyDaw/TinyDaw'
import ChordProgressionGenerator from './chordProgressionGenerator/ChordProgressionGenerator'
import BackingTrackGenerator from './backingTrackGenerator/BackingTrackGenerator'

const theme = createMuiTheme({
  palette: {
    primary: indigo,
    type: 'dark',
    background: {
      paper: '#3f4042'
    }
  },
})

// filter duplicate
let instruments = tunings.map(tuning => tuning.instrument)
instruments = instruments.filter((instrument, i) => instruments.indexOf(instrument) === i)

const sounds = ['synth', 'piano', 'guitar']

const useStyles = makeStyles((theme) => ({
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    // flexGrow: 1,
  },
  routes: {
    display: 'flex',
    flexGrow: 1,
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: 24
  },
  iconButtonSettings: {
    marginLeft: 12,
    // color: 'darkgrey',
    width: 72,
    height: 72
  },
  iconSettings: {
    fontSize: 32
  }
}))

const initialValue = 'Interactive Fretboard'

const fretsObject = { from: 0, amount: 22 }

const initialSettings = {
  instrument: instruments[0],
  tuning: tunings[0],
  sound: 'synth'
}

const constants = {
  tunings,
  instruments,
  sounds
}

function App() {
  const classes = useStyles()
  
  const [title, setTitle] = useState(initialValue)

  // const [instrument, setInstrument] = useState(instruments[0])
  // const [tuning, setTuning] = useState(tunings[0])
  
  const [settingsOpen, setSettingsOpen] = useState(false)

  const [settings, setSettings] = useState(initialSettings)

  
  // When instrument update -> set default tuning
  useEffect(() => {
    setSettings({ ...settings, tuning: tunings.find(tuning => tuning.instrument === settings.instrument)!})
  }, [settings.instrument])

  return (
    <ThemeProvider theme={theme}>
      <SnackbarProvider maxSnack={3}>
        <Router>
          <div>

            {/* A <Switch> looks through its children <Route>s and
                renders the first one that matches the current URL. */}
            <Switch>
              <Route path='/chord-finder'>
                <ChordFinder
                  settings={settings}
                  setTitle={setTitle}
                  fretsObject={fretsObject}
                  constants={constants}
                  onSettingsChange={setSettings}
                />
              </Route>
              {/* <Route path='/scale-visualizer'> */}
              <Route path='/scale-visualizer'>
                <ScaleVisualizer
                  settings={settings}
                  setTitle={setTitle}
                  fretsObject={fretsObject}
                  constants={constants}
                  onSettingsChange={setSettings}
                />
              </Route>
              {/* <Route path='/walking-bass-generator'>
                <WalkingBassGenerator
                  settings={settings}
                  setTitle={setTitle}
                />
              </Route> */}
              <Route path='/tiny-daw'>
                <TinyDaw
                  settings={settings}
                  setTitle={setTitle}
                  constants={constants}
                  onSettingsChange={setSettings}
                />
              </Route>
              <Route path='/chord-progression-generator'>
                <ChordProgressionGenerator
                  settings={settings}
                  setTitle={setTitle}
                  constants={constants}
                  onSettingsChange={setSettings}
                />
              </Route>
              <Route path='/backing-track-generator'>
                <BackingTrackGenerator
                  settings={settings}
                  setTitle={setTitle}
                  constants={constants}
                  onSettingsChange={setSettings}
                />
              </Route>
            </Switch>
          </div>
        </Router>
      </SnackbarProvider>
    </ThemeProvider>
  )
}

export default App

// TODO : scale finder
// TODO : chord visualizer
// TODO : play along
  // TODO : activate sound

// TODO : ADD, In C Lydian, it lacks the Cmaj7#11 chord (although Cmaj9#11 is present) maybe take those 9th chords and take away the 9th)

// TODO !!! : Chord to possibles scales

// TODO : add a color modal legend
// TODO : add shortcuts modal lists